import { useGraphEnum } from '@squareup/dex-feature-hooks-graph';
import { ReferenceObject } from '@squareup/dex-tech-reference-properties';
import { ReferenceHrefBuilders, toUrl } from '@squareup/dex-tech-utils-routing';
import { HeadWrapper } from '@squareup/dex-ui';
import { ContentLayoutGrid } from '@squareup/dex-ui-shared-content-layout-grid';
import {
  getNextPublicApiReferenceNameOrDefault,
  getNextPublicSquareDocsURL,
} from '@squareup/dex-utils-environment';
import { useParams } from '@squareup/dex-utils-shared-routing-hooks';
import React, { ReactNode, useMemo } from 'react';

import { SquareVersionPage } from '../../../../shared/SquareVersionPage';

const PageContent = () => {
  const { enum: enumValue } = useGraphEnum();
  const query = useParams();

  const square_version = query?.square_version as string;

  const backHref = useMemo(() => {
    return ReferenceHrefBuilders.versionEnums({
      square_version,
    });
  }, [square_version]);

  if (!enumValue) {
    return null;
  }

  const description = enumValue.summary ?? '';
  const title = `${
    enumValue.name
  } Enum - ${getNextPublicApiReferenceNameOrDefault()}`;

  return (
    <>
      <HeadWrapper
        description={description}
        preconnectUrl={getNextPublicSquareDocsURL()}
        title={title}
        canonicalPath={toUrl(
          ReferenceHrefBuilders.versionEnum({
            square_version,
            enum: enumValue.name,
          })
        )}
      />
      <ContentLayoutGrid singleColumn={true}>
        <section>
          <ReferenceObject
            entity={enumValue}
            eyebrow="Enum"
            showVersionSwitcher={true}
            backHref={backHref}
          ></ReferenceObject>
        </section>
      </ContentLayoutGrid>
    </>
  );
};

class Page extends SquareVersionPage {
  public static override routeHandlerName = '[square_version]/enums/[enum]';

  protected override getPageContent(): ReactNode {
    return super.getPageContent({
      children: <PageContent />,
    });
  }
}

export default Page;
